import * as React from 'react'
import { connect } from 'react-redux'

import { Product } from 'even-ts-static'

import { applicationFieldValidate } from 'common/actions/application'
import { lifeInsuranceApplicationStateOfResidenceSelector } from 'embed/selectors/application'
import { FieldDataValue, MultiProductDispatch } from 'embed/constants'
import { Fields } from 'embed/constants/fields'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'

import { StepbystepWrapper as Wrapper } from '../Wrapper'

import { LifeInsuranceApplicationProps } from '../container'

import { MultiProductState } from 'embed/reducers'

const styles = require('./styles.scss')

export interface StoreProps {
  stateOfResidence: FieldDataValue | undefined
}

export interface DispatchProps {
  dispatchValidateState: (value: FieldDataValue) => void
}

export interface OwnProps {
  handleConsentsToFCRAandTCPA: () => void
}

export type Props = StoreProps & DispatchProps & OwnProps

const UnconnectedApplicationStepStateOfResidence: React.SFC<LifeInsuranceApplicationProps & Props> = (props) => {
  React.useEffect(() => {
    props.setIsBeforeRouterQuestions(false)
    if (props.stateOfResidence) {
      // Validate the state of residence on the first render to make sure that the application is in a valid state
      // if we return to this step from the RequestACall form
      props.dispatchValidateState(props.stateOfResidence)
    }
  }, [])

  return (
    <Wrapper getOffersCta={true} {...props}>
      <StepTitle>What’s your state of residence?</StepTitle>
      <ApplicationField
        product={Product.LifeInsurance}
        field={Fields.State}
        onEnter={props.onContinue}
        styles={styles.formRow}
      />
    </Wrapper>
  )
}
const mapStateToProps = (state: MultiProductState): StoreProps => ({
  stateOfResidence: lifeInsuranceApplicationStateOfResidenceSelector(state),
})

const mapDispatchToProps = (dispatch: MultiProductDispatch): DispatchProps => ({
  dispatchValidateState: (value: FieldDataValue) =>
    dispatch(applicationFieldValidate(Product.LifeInsurance, Fields.State.key, value, true)),
})

export const ApplicationStepStateOfResidence = connect(
  mapStateToProps,
  mapDispatchToProps,
)(UnconnectedApplicationStepStateOfResidence)
